'use client';

import Flags from '@alltrails/experiments/components/Flags/Flags';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';

export default function FlagsWrapper() {
  const experiments = useExperiments();
  return <Flags userExps={experiments} />;
}
